import styles from './SearchComponent.module.scss'

const LoadingState = () => (
  <div className={styles.loadingState}>
    <p>Searching...</p>
  </div>
)

export default LoadingState
